import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = ['toggler', 'toggled'];

  toggle() {
    this.toggledTarget.classList.toggle('d-none')

    if(this.toggledTarget.classList.contains('d-none')) {
      let areaSelect = document.getElementById('organization_fax_number_request_attributes_area_code_id').selectize
      areaSelect.clear()
    }
  }
}
